import React, { FC, useEffect, useState } from 'react'
import {
    StyledInnerUserSettingsInput,
    StyledUserSettingsInput,
} from './UserSettingsInput.styled'
import { IconEditTN, IconEye } from '../../icons'
import { useProduct } from '../../__product'
import { Product } from '@news-mono/web-common'

interface UserSettingsInputProps {
    id: string
    label: string
    value?: string
    type?: 'text' | 'password' | 'edit'
    hasError?: boolean
    onChange: (val: string) => void
    onSelect?: () => void
    onEnter?: (e: React.KeyboardEvent<HTMLInputElement>) => void
    marginBottom?: number
    autoFocus?: boolean
}
export const UserSettingsInput: FC<UserSettingsInputProps> = ({
    label,
    id,
    type = 'text',
    value = '',
    hasError = false,
    onChange,
    onSelect,
    onEnter,
    marginBottom,
    autoFocus = false,
}) => {
    const [val, setVal] = useState<string>(value)
    const [inputType, setInputType] = useState<'text' | 'password' | 'edit'>(
        type,
    )
    const product = useProduct()
    const isNotPn = product !== Product.PerthNow
    const [error, setError] = useState<boolean>(hasError)
    const [eyeClose, setEyeClose] = useState<boolean>(false)
    useEffect(() => {
        setVal(value)
        setError(hasError)
    }, [value, hasError, type])

    function onInput(e: React.ChangeEvent<HTMLInputElement>) {
        setVal(e.target.value)
        onChange(e.target.value)
        setError(false)
    }

    function onEyeIconClick() {
        setInputType(inputType === 'password' ? 'text' : 'password')
        setEyeClose(!eyeClose)
    }
    return (
        <StyledUserSettingsInput
            isFilled={!!val}
            hasError={isNotPn && error}
            marginBottom={marginBottom}
            hasIcon={type !== 'text'} // We use type not inputType as we want the original value of the input.
        >
            <StyledInnerUserSettingsInput
                hasError={isNotPn && error}
                isFilled={!!val}
            >
                <input
                    type={inputType}
                    id={id}
                    value={val}
                    onChange={onInput}
                    onSelect={onSelect}
                    autoFocus={autoFocus}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault()
                            onEnter && onEnter(e)
                        }
                    }}
                />
                <label htmlFor={id}>{label}</label>
            </StyledInnerUserSettingsInput>
            {type === 'password' && (
                <IconEye
                    eyeClose={eyeClose}
                    onClick={onEyeIconClick}
                    hasError={isNotPn && error}
                />
            )}
            {type === 'edit' && <IconEditTN hasError={isNotPn && error} />}
        </StyledUserSettingsInput>
    )
}
